import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { WVCustom, WVMain } from '../wallboard-view.model';
import { ImageSettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-custom-image',
    templateUrl: './wallboard-view-custom-image.component.html',
    styleUrls: ['./wallboard-view-custom-image.component.scss']
})
export class WallboardViewCustomImageComponent implements OnInit, OnDestroy {
    @Input() index: number;
    @Input() height: number;
    @Input() width: number;
    @Input() firstSlide;
  
    public wvf: WVMain;
    public wvcf: WVCustom;
    public imageState: ImageSettingsTransferObj;

    public slideError: boolean = false;
    public imgHeight: number | string;
    public imgWidth: number | string;
    public imageAspect: number;
    public containerAspect: number;

    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;
        this.slideError = false;
        
        this._hasBackdrop = this.wvcf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvcf?.Slide.WallboardModuleDetails[this.index].WallboardModuleKey ?? "";

        this.imgHeight = Math.floor(+this.height);
        this.imgWidth = Math.floor(+this.width);

        this.loadModuleState().then(response => {
            if (this.isDestroyed)
                return;

            this.imageState = response.imgObj;

            this.setUpImageAspect().then(response => {
                if (this.isDestroyed)
                    return;

                this.imageAspect = response;

                this.containerAspect = +this.imgHeight / +this.imgWidth;

                if (+this.imgWidth >= +this.imgHeight * +this.imageAspect)
                    this.imgWidth = "auto";
                    //this.imgHeight = "auto";
                else
                    this.imgHeight = "auto";
                    //this.imgWidth = "auto";

                if (!this.firstSlide)
                    this.wvcf.ReadyModules.push(this.moduleKey);
            });
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    public async loadModuleState() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.service.loadModuleState(ModuleType.ImageModule, this.wvf.WallboardCreatorID, this.moduleKey);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.slideError = true;

        if (!this.firstSlide)
            this.wvcf.ReadyModules.push(this.moduleKey);

        throw latestError;
    }

    public async setUpImageAspect() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.wallboardsService.getImageAspect(this.imageState.UploadedImageID);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.slideError = true;

        if (!this.firstSlide)
            this.wvcf.ReadyModules.push(this.moduleKey);

        throw latestError;
    }
}
